import React, { useState } from "react";
import _ from "lodash";
import ModalCustom from "../Common/ModalCustom";
import StripeCheckoutForm from "./StripeCheckoutForm";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_URL);

const SubscriptionBox = ({ subscriptionDataList }) => { // NOSONAR
  const [showStripeCheckoutForm, handleStripeCheckoutFormPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();
  const [isEmeraldOrAbove, setIsEmeraldOrAbove] = useState(false);

  const handleStripeCheckoutForm = (subscriptionData, showTalkToNtr) => {
    handleStripeCheckoutFormPopup(false);
    setSelectedProduct(subscriptionData);
    handleStripeCheckoutFormPopup(true);
    setIsEmeraldOrAbove(showTalkToNtr)
  };

  const emeraldPlan = subscriptionDataList.filter((plan) => plan.title === 'Emerald')[0] // NOSONAR
  //   return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // }

  return (
    <>
      <div>
        {_?.map(subscriptionDataList, (subscriptionData, index) => (
          <div
            key={index}
            className={`plan ${subscriptionData?.title === 'Emerald' && 'active'} my-4 bg-light rounded-4 d-sm-flex justify-content-between gap-2 align-items-center py-3 px-4`}
          >
            <h4 className="plan-title text-uppercase fs-5 mb-0 text-sm-center">{subscriptionData?.title}</h4>
            <div className="plan-price d-inline-flex my-2 me-4 my-sm-0">
              <small className="pt-1">$</small>
              <div className="amount fw-normal lh-noraml">{Math.floor(subscriptionData?.price)}.</div>
              <small className="pt-1">{subscriptionData?.price.toString().split('.')[1]}</small>
              <span className="align-content-around mt-3 text-muted fw-medium">/{subscriptionData?.subTitle}</span>

              {subscriptionData?.title === 'Emerald' && (
                <div className="text-primary fw-medium small mt-4 ms-3 ps-2 text-nowrap">
                  10% Savings
                </div>
              )}
              {subscriptionData?.title === 'Ruby' && (
                <div className="text-primary fw-medium small mt-4 ms-3 ps-2 text-nowrap">
                  20% Savings
                </div>
              )}
            </div>

            <button
              type="button"
              className="fw-medium fs-5 py-1 px-2 rounded-3 text-uppercase"
              onClick={() => handleStripeCheckoutForm(subscriptionData, Number(subscriptionData.price) >= Number(emeraldPlan.price))}
            >
              {"CHOOSE  " + subscriptionData?.title}
            </button>
          </div>

        ))}
      </div>

      <ModalCustom
        size="xs"
        show={showStripeCheckoutForm}
      >
        <Elements stripe={stripePromise}>
          <StripeCheckoutForm
            checkoutFormType='subscription'
            selectedProduct={selectedProduct}
            handleStripeCheckoutFormPopup={handleStripeCheckoutFormPopup}
            isEmeraldOrAbove={isEmeraldOrAbove}
          />
        </Elements>
      </ModalCustom>
    </>
  );
};

export default SubscriptionBox;
